import {
  ClientStatementPaymentStatus,
  ClientStatementStatus,
} from 'uplisting-frontend/models/client-statement';
import {
  FilterId,
  FilterOptionsType,
  SingleSelectFilter,
} from 'uplisting-frontend/utils/filters/abstract';

export class ClientStatementStatusFilter extends SingleSelectFilter<void> {
  id = FilterId.clientStatementStatus;
  optionsType = FilterOptionsType.list;
  optionsList = [ClientStatementStatus.draft, ClientStatementStatus.finalised];
}

export class ClientStatementPaymentStatusFilter extends SingleSelectFilter<void> {
  id = FilterId.clientStatementPaymentStatus;
  optionsType = FilterOptionsType.list;
  optionsList = [
    ClientStatementPaymentStatus.paid,
    ClientStatementPaymentStatus.unpaid,
    ClientStatementPaymentStatus.unknown,
  ];
}
